import classNames from "classnames";
import { ActionIcon } from "PFComponents/action_icon";
import { IconName } from "PFTheme/graphics/icons";
import React from "react";

import css from "./navigation_pill.module.scss";

export type NavigationItem<ID> =
  | {
      id: ID;
      type: "icon";
      iconName: IconName;
      onClick: VoidFunction;
    }
  | {
      id: ID;
      type: "separator";
    };

type NavigationPillProps<ID> = {
  items: NavigationItem<ID>[];
  activeItemId: ID | null;
  className?: string;
};

export const NavigationPill = <ID extends string>({
  items,
  activeItemId,
  className
}: NavigationPillProps<ID>): JSX.Element => (
  <div className={classNames(css.root, className)}>
    {items.map((item) => {
      const { id, type } = item;

      if (type === "icon") {
        const { iconName, onClick } = item;
        const isItemActive = id === activeItemId;

        return (
          <ActionIcon
            key={id}
            name={iconName}
            color="paletteWhite0"
            size="md"
            onClick={onClick}
            disableHover
            classes={{
              root: classNames(css.item, { [css.activeItem]: isItemActive })
            }}
          />
        );
      } else if (type === "separator") {
        return <div key={id} className={css.separator} />;
      }
    })}
  </div>
);
